import { Spin } from "antd";
import { useDetailsNotiy } from "../hooks/use-details-notify";
import moment from "moment";
import { DateFormat } from "../../../constants";

export const NotifyDetails = () => {
  const { data, isLoading } = useDetailsNotiy();

  if (isLoading) return <Spin />;


  return data ? (
    <div className="content__notify-right">
      <div className="header">
        <div className="title__notify-custom">
          <div className="title__notify">{data.title}</div>
        </div>
        <div className="content__notify-custom">
          <div className="content__notify-title">
            <h6>Nội dung</h6>
            <p>{moment(data.timeReceived).format(DateFormat.DD_MM_YYYY_HH_MM)}</p>
          </div>
          <div className="content__notify" dangerouslySetInnerHTML={{ __html: data.content }} />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
